import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import RouteService from "../../../service/routeService";
import { GraphQLClient } from "../../../../../../../shared/gql-client";
import { PlanningSliceModel } from "../../PlanningSlice";
import { RouteModel } from "../../../../domain/models/routeModel";
import { getRequestsFromDay } from "../../PlanningThunks";

const routeApi = new RouteService();

/**
 *
 */
export const getPlanningRoutes = createAsyncThunk(
  "planning/get/routes",
  async (day: string | undefined, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    try {
      const { planning } = thunkAPI.getState() as {
        planning: PlanningSliceModel;
      };

      routeApi.setClient(client);

      const result = await routeApi.getRoutesFromDay(day ?? planning.date);
      await thunkAPI.dispatch(getRequestsFromDay(day ?? planning.requestsDate));
      return result;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const extraReducersGetPlanningRoutes = (
  builder: ActionReducerMapBuilder<PlanningSliceModel>,
) => {
  builder.addCase(getPlanningRoutes.fulfilled, (state, action) => {
    state.loading = false;

    state.routes = (action.payload as RouteModel[]).map((route) => {
      return {
        ...route,
        packingSlips: [...route.packingSlips].sort((a, b) => {
          if (a.weight == null && b.weight == null) return 0; // Both null/undefined, keep order
          if (a.weight == null) return -1; // a is null/undefined, move it up
          if (b.weight == null) return 1; // b is null/undefined, move it up
          return a.weight - b.weight; // Otherwise, sort by ascending weight
        }),
      };
    });
  });
};
